/**
 * 路由模块统一导出
 */
import type { RouteRecordRaw } from 'vue-router'

// 导入各模块路由
import authRoutes from './auth'
import userRoutes from './user'
import systemRoutes from './system'
import messageRoutes, { profileMessagesRoute } from './message'
import projectRoutes from './project'
import taskRoutes from './task'
import videoRoutes from './video'
import usageRoutes from './usage'
import documentRoutes from './document'
import teachingRoutes from './teaching'
import reportRoutes from './report'
import crRoutes from './cr'
import speechTranslationRoutes from './speech-translation'

/**
 * 获取所有模块路由
 * @param isLayoutRoute 是否为布局路由的子路由
 * @returns 路由配置数组
 */
export function getModuleRoutes(isLayoutRoute = false): RouteRecordRaw[] {
  const routes: RouteRecordRaw[] = []

  // 认证路由（不需要布局）
  if (!isLayoutRoute) {
    routes.push(...authRoutes)
  }

  // 布局内的路由
  if (isLayoutRoute) {
    routes.push(
      ...projectRoutes,
      ...videoRoutes,
      ...taskRoutes,
      ...documentRoutes,
      ...teachingRoutes,
      ...reportRoutes,
      ...usageRoutes,
      ...messageRoutes,
      ...crRoutes,
      ...speechTranslationRoutes,
      ...systemRoutes,
    )
  }

  return routes
}

/**
 * 获取用户相关路由（用于个人中心等嵌套路由）
 */
export function getUserRoutes(): RouteRecordRaw[] {
  return [
    ...userRoutes.filter(route => route.name === 'PersonalInfo'),
    profileMessagesRoute,
    ...usageRoutes.filter(route => route.name === 'UsageHistory')
  ]
}

/**
 * 获取系统管理路由（用于系统管理嵌套路由）
 */
export function getSystemRoutes(): RouteRecordRaw[] {
  return systemRoutes[0]?.children || []
}

// 导出各模块路由（供单独使用）
export { default as authRoutes } from './auth'
export { default as userRoutes } from './user'
export { default as systemRoutes } from './system'
export { default as messageRoutes, profileMessagesRoute } from './message'
export { default as projectRoutes } from './project'
export { default as taskRoutes } from './task'
export { default as videoRoutes } from './video'
export { default as usageRoutes } from './usage'
export { default as documentRoutes } from './document'
export { default as teachingRoutes } from './teaching'
export { default as reportRoutes } from './report'
export { default as crRoutes } from './cr'

